// setup

import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { useEffect, useState } from 'react'
import { ButtonNewRow } from './ButtonNewRow'
import { ActionBasicEditCellName, ActionConfirmEditCellName, IEditRow, ITableEditableParams, TData } from './TableEditableConfig';

// only table editable
export default function TableEditable(params: ITableEditableParams) {
  // field
  const [originalData, setOriginalData] = useState<TData[]>(() => [...params.fetchData])
  const [data, setData] = useState<TData[]>(() => [...params.fetchData])
  const [editedRows, setEditedRows] = useState<IEditRow[]>(() => [...params.fetchData].map((_item, index) => ({ id: index, isEdit: false, actionBasic: ActionBasicEditCellName.None, actionConfirm: ActionConfirmEditCellName.None, })))

  const columns = params.columns
  useEffect(() => {
    params.handleSave && params.handleSave(originalData, params.param)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.fetchData, originalData]);

  const handleResetIdData = (data: TData[], originData: TData[], index: number) => {
    // id: stt
    // index: array
    let removeData = data.filter(f => f.id - 1 !== index).map((element, index) => ({ ...element, ...{ id: index + 1 } }))
    let removeOriginData = originData.filter(f => f.id - 1 !== index).map((element, index) => ({ ...element, ...{ id: index + 1 } }))
    setData(removeData)
    setOriginalData(removeOriginData)

  }
  const handleResetIdEditedRow = (data: IEditRow[], id: number) => {
    let removeEditedRow = data.filter(f => f.id !== id).map((element, index) => ({ ...element, ...{ id: index } }))
    setEditedRows(removeEditedRow)
  }
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    // optional có thể tuỳ biến
    meta: {
      editedRows,
      setEditedRows,
      revertData: (rowIndex: number, actionBasic: ActionBasicEditCellName) => {
        if (actionBasic === ActionBasicEditCellName.Edit) {
          setData((old) => old.map((row, index) => index === rowIndex ? originalData[rowIndex] : row))
        } else {
          setData((old) => old.filter((_row, index) => index !== rowIndex))
          setEditedRows((old) => old.filter((_row, index) => index !== rowIndex))
        }
      },
      updateData: (rowIndex: number, actionBasic: ActionBasicEditCellName) => {
        if (actionBasic === ActionBasicEditCellName.Edit) {
          setOriginalData((old) =>
            old.map((row, index) => (index === rowIndex ? data[rowIndex] : row))
          )
        } else {
          let dataUpdate = [...originalData, data[rowIndex]]
          setOriginalData(dataUpdate)
        }

      },
      blurData: (rowIndex: number, columnId: string, value: any) => {
        // blur 
        setData((old) =>
          old.map((row, index) => (index === rowIndex) ? {
            ...old[rowIndex],
            [columnId]: value,
          } :
            row
          ))
      },
      addRow: (e: any) => {
        if (params.newRow) {
          params.newRow.id = data.length + 1
          let newData = [...data, params.newRow]
          let id = newData.length - 1

          // addNew
          let editedRowsUpdate = [...editedRows]
          editedRowsUpdate.push({ id: id, isEdit: true, actionBasic: ActionBasicEditCellName.Add, actionConfirm: ActionConfirmEditCellName.None })
          setEditedRows(editedRowsUpdate)
          setData(newData)
        }
      },
      removeRow: (rowIndex: number) => {
        let removeData = [...data]
        let removeOriginalData = [...originalData]
        handleResetIdData(removeData, removeOriginalData, rowIndex)
        handleResetIdEditedRow(editedRows, rowIndex)
      },
    },
  })
  // template 
  // header
  const theadTmp = (
    <thead>
      {
        table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <th key={header.id}>
                {header.isPlaceholder
                  ? null
                  : flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
              </th>
            ))}
          </tr>
        ))
      }
    </thead>
  )


  const tbodyTmp = (
    <tbody>
      {
        table.getRowModel().rows.map((row) => (
          <tr key={row.id}>
            {row.getVisibleCells().map((cell) => (
              <td key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        ))
      }
    </tbody>
  )


  const tfooterTmp = params.newRow ? (
    <tfoot>
      <tr>
        <th colSpan={table.getCenterLeafColumns().length}>
          <ButtonNewRow table={table} editRow={editedRows[editedRows.length - 1]} />
        </th>
      </tr>
    </tfoot>
  ) : null


  return (
    <table className='table table-sm table-responsive-sm table-bordered' id={params.id}>
      <caption className='caption-top'>List of TableEditable</caption>

      {theadTmp}
      {tbodyTmp}
      {tfooterTmp}

    </table>
  )
}